import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import { AdminCard } from '../AdminUI';

const AdminTrendChart = ({ data, dataKey, stroke = '#8884d8', type = 'line' }) => {
  const hasData = Array.isArray(data) && data.length > 0;
  const isDark = document.documentElement.getAttribute('data-theme') === 'dark';

  const option = useMemo(() => {
    if (!hasData) return null;

    const labels = data.map((item) => item.date);
    const axisColor = isDark ? '#94a3b8' : '#64748b';
    const gridColor = isDark ? 'rgba(148,163,184,0.2)' : 'rgba(148,163,184,0.35)';
    const tooltipBg = isDark ? '#0f172a' : '#ffffff';
    const tooltipText = isDark ? '#f8fafc' : '#0f172a';

    if (type === 'financial-combo') {
      return {
        animationDuration: 700,
        grid: { left: 36, right: 36, top: 36, bottom: 28, containLabel: true },
        legend: { top: 4, textStyle: { color: axisColor } },
        tooltip: {
          trigger: 'axis',
          backgroundColor: tooltipBg,
          borderColor: gridColor,
          textStyle: { color: tooltipText },
          axisPointer: { type: 'cross' }
        },
        xAxis: { type: 'category', data: labels, axisLabel: { color: axisColor }, axisLine: { lineStyle: { color: gridColor } } },
        yAxis: [
          { type: 'value', axisLabel: { color: axisColor }, splitLine: { lineStyle: { color: gridColor } } },
          { type: 'value', axisLabel: { color: axisColor }, splitLine: { show: false } }
        ],
        series: [
          { name: 'Income', type: 'bar', data: data.map((d) => d.income || 0), itemStyle: { color: '#10b981', borderRadius: [6, 6, 0, 0] } },
          { name: 'Revenue', type: 'line', smooth: true, symbol: 'none', lineStyle: { width: 3, color: '#3b82f6' }, data: data.map((d) => d.revenue || 0) },
          { name: 'Commissions', type: 'line', yAxisIndex: 1, smooth: true, symbol: 'none', lineStyle: { width: 3, color: '#f59e0b' }, data: data.map((d) => d.commissions || 0) }
        ]
      };
    }

    return {
      animationDuration: 650,
      grid: { left: 30, right: 16, top: 18, bottom: 24, containLabel: true },
      tooltip: {
        trigger: 'axis',
        backgroundColor: tooltipBg,
        borderColor: gridColor,
        textStyle: { color: tooltipText }
      },
      xAxis: { type: 'category', data: labels, axisLabel: { color: axisColor }, axisLine: { lineStyle: { color: gridColor } } },
      yAxis: { type: 'value', axisLabel: { color: axisColor }, splitLine: { lineStyle: { color: gridColor } } },
      series: [
        {
          type: 'line',
          smooth: true,
          symbol: 'none',
          data: data.map((item) => item[dataKey] || 0),
          lineStyle: { width: 3, color: stroke },
          areaStyle: type === 'area' ? { color: stroke, opacity: 0.18 } : undefined
        }
      ]
    };
  }, [data, dataKey, hasData, isDark, stroke, type]);

  return (
    <AdminCard className="h-72">
      {hasData ? <ReactECharts option={option} style={{ height: '100%', width: '100%' }} notMerge lazyUpdate /> : (
        <div className="flex h-full items-center justify-center text-sm text-slate-500 dark:text-slate-400">
          No chart data for this range.
        </div>
      )}
    </AdminCard>
  );
};

export default AdminTrendChart;
